import { IComponent } from "../types/IComponent";

export const IsComponentValid = (component: IComponent): boolean => {

  return component.issuedQty >= component.plannedQty;
}